import React from 'react';
import Busea from './components/containers/Busea';

function App() {
  return <Busea />;
}

export default App;
